import React from "react";

const Java_sin = () => {
  return (
    <div>
      <h1>Java sin</h1>
      <p>This page provides explanations, examples, and common use-cases for Java sin in Java.</p>
    </div>
  );
};

export default Java_sin;
